export const PORTAL_TITLE = "Capital One Travel Portal";
export const HOTEL_CHECKOUT_TITLE = "Complete Hotel Booking";
export const VACATION_RENTAL_CHECKOUT_TITLE =
  "Complete Vacation Rental Booking";
